import { SetupPermission } from 'src/app/core';
import { PermissionsC } from 'src/permissions/helpers/permissions.class';

export const DataRewards: SetupPermission = PermissionsC.setupPages({
  pageLabels: ['offers-databack-management'],
  productLineLabel: 'data-rewards',
});
